import React from 'react'

export default function viewcctvquote() {
  return (
    <div>
      
    </div>
  )
}
